var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import { mapState } from 'vuex';
import moment from 'moment';
import menuReturn from '../../components/console-common/menu-return.vue';
import contractCard from '../../components/console-common/contract-board.vue';
import contractView from '../../components/contract/contract-view.vue';
import batchImport from '../../components/console-common/batch-import-polling.vue';
import textarea from '../../components/console-common/common-textarea.vue';
import { toYuan, toFen } from '../../utils/unit-conversion';
export default Vue.extend({
    name: 'driverGrant',
    components: {
        'el-menu-return': menuReturn,
        'el-contract-card': contractCard,
        'el-batch-import': batchImport,
        'el-textarea-model': textarea,
        'el-contract-view': contractView,
    },
    computed: __assign({}, mapState('balance', {
        balanceData: 'balanceData',
    }), { draw: function () {
            var draw = this.balanceData !== undefined ? this.balanceData.draw : '';
            return draw !== '' ? toYuan(draw).toFixed(2) : '';
        } }),
    created: function () {
        this.$store.dispatch('balance/GET_BALANCE');
    },
    data: function () {
        return {
            contractData: [],
            contractDataOrigin: [],
            grantType: 'batch',
            ele: '',
            loadingMain: '',
            isShowRemark: false,
            contractMsg: null,
            titleConfig: {
                backTitle: '返回',
                currentTitle: '发放',
                routerName: true,
                name: 'driverSupAward',
            },
            supplement: [
                {
                    label: '奖励',
                    val: 'AWARD',
                },
                {
                    label: '补贴',
                    val: 'ALLOWANCE',
                },
                {
                    label: '退款',
                    val: 'REFUND',
                },
            ],
            grantForm: {
                criteria: '',
                amount: '',
                type: '',
                remark: '',
            },
            grantRules: {
                criteria: [
                    {
                        required: true,
                        message: '请输入合同号/司机姓名/手机号/车牌号',
                        trigger: 'blur',
                    },
                ],
                amount: [
                    { required: true, message: '请输入补款金额', trigger: 'blur' },
                    { required: true, validator: this.validatorNum, trigger: 'blur' },
                ],
                type: [
                    { required: true, message: '请选择补款原因', trigger: 'change' },
                ],
            },
            detail: {
                orderNo: '',
                status: '',
                list: [],
            },
        };
    },
    watch: {
        contractData: function (val) {
            if (val.length === 1) {
                this.getCurrentContract(0);
            }
        },
        'grantForm.criteria': function (val) {
            if (!val) {
                this.contractData = [];
                this.contractDataOrigin = [];
                this.contractMsg = null;
            }
        },
    },
    methods: {
        batchGrant: function (key) {
            var _this = this;
            this.loadingMain = Vue.prototype.$loading({
                spinner: 'el-icon-loading',
                background: 'rgba(300, 300, 300, 0.5)',
                customClass: 'loading',
                body: true,
            });
            this.$request({
                url: '/proxy/api/reward/batchReward',
                method: 'post',
                data: {
                    fileGiftKey: key,
                },
                loadingControl: 'hand',
            }).then(function (res) {
                if (!res || res.errorCode) {
                    return _this.loadingMain.close();
                }
                _this.batchPolling(key);
            });
        },
        batchPolling: function (key) {
            var _this = this;
            var times = 0;
            var pollingMain = function () {
                if (times > 13) {
                    _this.$message.error('网络超时，请稍后重试！');
                    return _this.loadingMain.close();
                }
                _this.batchCheckStatus(key).then(function (res) {
                    if (!res || res.errorCode) {
                        _this.$message.error(res.errorMsg);
                        return _this.loadingMain.close();
                    }
                    if (!res.data) {
                        times++;
                        setTimeout(function () {
                            pollingMain();
                        }, 1500);
                        return;
                    }
                    _this.loadingMain.close();
                    if (res.data === 'success') {
                        _this.$confirm('', '', {
                            message: "<p class=\"title\">\u6210\u529F\u53D1\u653E</p><p class=\"text\">\u53EF\u524D\u5F80\u53F8\u673A\u8865\u6B3E\u5956\u52B1\u5217\u8868\u67E5\u770B</p>",
                            dangerouslyUseHTMLString: true,
                            confirmButtonText: '前往查看',
                            cancelButtonText: '好的',
                            type: 'warning',
                            showClose: false,
                        })
                            .then(function () {
                            _this.$router.push({ name: 'driverSupAward' });
                        })
                            .catch(function () {
                            _this.$store.commit('common/update', {
                                percentage: 0,
                                showChangeFileBtn: true,
                                changeBtnName: '取消',
                            });
                        });
                        _this.$store.dispatch('balance/GET_BALANCE');
                    }
                    else {
                        _this.$confirm('', '', {
                            message: "<p class=\"title\">\u5B58\u5728\u53D1\u653E\u5931\u8D25\u7684\u5956\u52B1\u8865\u6B3E</p>",
                            dangerouslyUseHTMLString: true,
                            confirmButtonText: '下载信息',
                            cancelButtonText: '取消',
                            type: 'warning',
                            showClose: false,
                        })
                            .then(function () {
                            window.open(res.data);
                        })
                            .catch(function () { });
                    }
                });
            };
            pollingMain();
        },
        batchCheckStatus: function (key) {
            return this.$request({
                method: 'post',
                url: "/proxy/api/reward/batchRewardResult",
                data: {
                    fileGiftKey: key,
                },
                loadingControl: 'hand',
            });
        },
        tabGrantType: function (val) {
            val.name === 'single' && this.$refs['grantForm'].resetFields();
            this.isShowRemark = false;
            this.grantForm.remark = '';
            this.detail = {
                orderNo: '',
                status: '',
                list: [],
            };
        },
        validatorNum: function (rule, value, callback) {
            var reg = /^[0-9]+(\.[0-9]{1,2})?$/;
            if (!reg.test(value)) {
                return callback(new Error('请输入数字，最多两位小数'));
            }
            else if (value <= 0) {
                return callback(new Error('补款金额不能为0'));
            }
            else if (value > 10000) {
                return callback(new Error('补款金额不能超过10000元'));
            }
            else {
                callback();
            }
        },
        queryContract: function () {
            var _this = this;
            var criteria = this.grantForm.criteria;
            var reg = /(^\s*)|(\s*$)/g;
            this.contractMsg = null;
            this.contractDataOrigin = [];
            this.contractData = [];
            if (criteria === undefined) {
                return;
            }
            criteria = criteria.replace(reg, '');
            this.$request({
                method: 'post',
                url: '/proxy/api/contract/get/fuzzy',
                data: {
                    criteria: criteria,
                },
            }).then(function (res) {
                if (!res) {
                    return;
                }
                if (!res.errorCode) {
                    var leaseFormatter = function (leaseMode) {
                        var txt = {
                            JINGZU: '经租',
                            RONGZU: '融租',
                        };
                        return txt[leaseMode];
                    };
                    _this.getContractList(res.data, leaseFormatter);
                }
            });
        },
        getContractList: function (data, leaseModes) {
            var _this = this;
            if (data.length <= 0) {
                return;
            }
            this.contractDataOrigin = data;
            this.contractData = [];
            data.forEach(function (item) {
                var obj = {
                    orderNo: '',
                    status: '',
                    active: false,
                    list: [],
                };
                obj.orderNo = item.contractCode;
                obj.status = item.activeState;
                obj.list = [
                    {
                        key: '司机姓名',
                        val: item.driverName,
                    },
                    {
                        key: '车牌号',
                        val: item.plateNumber,
                        push: 3,
                    },
                    {
                        key: '注册手机号',
                        val: item.driverMobile,
                        span: 24,
                    },
                    {
                        key: '业务模式',
                        val: leaseModes[item.leaseMode],
                        span: 12,
                    },
                    {
                        key: item.leaseMode === 'JINGZU' ? '总租金' : '总额',
                        val: "\uFFE5" + _this.$utils.toYuan(item.totalAmount),
                        push: 3,
                    },
                    {
                        key: '合同有效期',
                        val: moment(item.startTime).format('YYYY-MM-DD') + " \u81F3 " + moment(item.endTime).format('YYYY-MM-DD'),
                        span: 24,
                    },
                ];
                _this.contractData.push(obj);
            });
        },
        getCurrentContract: function (index) {
            this.contractData.forEach(function (item) {
                item.active = false;
            });
            this.contractData[index]['active'] = true;
            this.contractMsg = this.contractDataOrigin[index];
        },
        addRemark: function () {
            this.isShowRemark = !this.isShowRemark;
        },
        submitForm: function (form) {
            var _this = this;
            this.$refs[form].validate(function (valid) {
                if (!valid) {
                    return;
                }
                var detail = _this.contractData && _this.contractData.length;
                if (!detail) {
                    _this.$message.error('请先提取合同');
                    return;
                }
                if (_this.contractMsg === null) {
                    _this.$message.error('请先选择合同');
                    return;
                }
                var _a = _this.contractMsg, driverMobile = _a.driverMobile, driverName = _a.driverName, driverUid = _a.driverUid, contractCode = _a.contractCode;
                var amount = _this.grantForm.amount;
                var params = Object.assign({}, _this.grantForm, {
                    driverName: driverName,
                    driverPhone: driverMobile,
                    driverUid: driverUid,
                    contractCode: contractCode,
                }, {
                    amount: toFen(amount),
                });
                if (!_this.isShowRemark) {
                    params.remark = '';
                }
                if (params.remark.length > 50) {
                    return _this.$message.error('备注字符数超出最大值');
                }
                _this.$request({
                    url: '/proxy/api/reward/singleReward',
                    method: 'POST',
                    data: params,
                }).then(function (res) {
                    if (!res || res.errorCode) {
                        return;
                    }
                    _this.$message({
                        message: '单个发放申请成功',
                        type: 'success',
                    });
                    _this.$store.dispatch('balance/GET_BALANCE');
                    _this.$refs[form].resetFields();
                    _this.isShowRemark = false;
                    _this.detail = {
                        orderNo: '',
                        status: '',
                        list: [],
                    };
                });
            });
        },
    },
});
